import { clsx } from '@appvantageasia/core-utils';
import {
    Root,
    Image,
    Fallback,
    type AvatarProps as AvatarWrapperProps,
    type AvatarImageProps,
    type AvatarFallbackProps,
} from '@radix-ui/react-avatar';
import words from 'lodash/fp/words';

const getInitials = (str: string) => {
    return words(str)
        .map(word => word.charAt(0).toUpperCase())
        .join('');
};

const AvatarWrapper = ({ className, ...props }: AvatarWrapperProps) => (
    <Root className={clsx('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', className)} {...props} />
);

const AvatarImage = ({ className, ...props }: AvatarImageProps) => (
    <Image className={clsx('aspect-square h-full w-full', className)} {...props} />
);

const AvatarFallback = ({ className, ...props }: AvatarFallbackProps) => (
    <Fallback
        className={clsx(
            'bg-muted flex h-full w-full items-center justify-center rounded-full text-sm font-semibold',
            className
        )}
        {...props}
    />
);

interface AvatarProps {
    name?: string;
    imageUrl?: string;
}

const Avatar = ({ name, imageUrl }: AvatarProps) => {
    return (
        <AvatarWrapper>
            <AvatarImage src={imageUrl} />
            <AvatarFallback className="bg-primary text-primary-foreground">{getInitials(name || '')}</AvatarFallback>
        </AvatarWrapper>
    );
};

export default Avatar;
